/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { request as __request } from "../../helpers/api/request";
import type { BaseSystemResponse } from "../../models/systems/BaseSystemResponse";
import type { SystemItemResponse } from "../../models/systems/SystemItemResponse";
import type { SystemResponse } from "../../models/systems/SystemResponse";

export class SystemsService {
  /**
   * @param id
   * @returns SystemResponse Success
   * @throws ApiError
   */
  public static async getById(id: number): Promise<SystemResponse> {
    const result = await __request({
      method: "GET",
      path: `/systems/${id}`,
    });
    return result.body;
  }

  /**
   * @returns SystemResponse Success
   * @throws ApiError
   */
  public static async getAll(): Promise<Array<SystemResponse>> {
    const result = await __request({
      method: "GET",
      path: `/systems`,
    });
    return result.body;
  }

  /**
   * @param id
   * @returns SystemResponse Success
   * @throws ApiError
   */
  public static async getByBaseSystemId(id: number): Promise<Array<SystemResponse>> {
    const result = await __request({
      method: "GET",
      path: `/systems/basesystem/${id}`,
    });
    return result.body;
  }

  /**
   * @param id
   * @returns SystemItemResponse Success
   * @throws ApiError
   */
  public static async getSystemItems(id: number): Promise<Array<SystemItemResponse>> {
    const result = await __request({
      method: "GET",
      path: `/systems/${id}/systemitems`,
    });
    return result.body;
  }

  /**
   * @returns BaseSystemResponse Success
   * @throws ApiError
   */
  public static async getAllBaseSystems(): Promise<Array<BaseSystemResponse>> {
    const result = await __request({
      method: "GET",
      path: `/systems/basesystems`,
    });
    return result.body;
  }
}
